import React, { useState, useEffect, useRef } from "react";
import { MdOutlineReportProblem } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { CiImageOn } from "react-icons/ci";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import "./Preview.css";
import { IoBedOutline } from "react-icons/io5";
import { TbBath } from "react-icons/tb";
import { RxDimensions } from "react-icons/rx";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import axios from "axios";
import DetailsAndFacts from "./DetailAndFact";
import { BsShare } from "react-icons/bs";
import LeafletLocateMapLocation from "./LeafletLocateMap";
import MLSDisclaimer from "./MLSDisclaimer";
import { PiBarbell, PiGarage } from "react-icons/pi";
import { useProfile } from "../../contexts/ProfileContext";
import { Image } from "antd";
import { FaSwimmingPool } from "react-icons/fa";
import { FaSunPlantWilt } from "react-icons/fa6";
import PriceAndContactCard from "./PriceAndContactCard";
import ShareComponent from "../ShareComponent/ShareComponent";
import PropertyComponent from "../PropertyComponent";
import FeatureChipsContainer from "../../pages/MyProperties/FeatureChipsContainer";
import CustomDatePickerComponent from "../CustomDatePickerComponent";
import SeeAllImages from "../../pages/MyProperties/SeeAllImages";
import config from "../../config";
import { showErrorToast, showSuccessToast } from "../../pages/utils";
import ReportProperty from "../../pages/MyProperties/ReportProperty";
import RenderImages from "../../pages/Preview/RenderImages";

const PropertyDetailPage = ({
    publicProperty,
    id,
    setPreviewModal,
    handleFavorite,
    propertiesArray,
    favoriteProperties = [],
    isShareModal,
    setIsShareModal,
    isHeaderHide = false,
    isChatScreen,
}) => {
    const { profileData } = useProfile();
    const [seeAllclicked, setSeeAllclicked] = useState(false);
    const [property, setProperty] = useState(publicProperty);
    const [showTourModal, setShowTourModal] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [profileDetail, setProfileDetail] = useState({
        firstName: "",
        lastName: "",
        email: "",
        role: "",
        phone: "",
        userId: "",
        profile_pic: "",
    });
    const [isFavorite, setIsFavorite] = useState(false);
    const [isReportModalVisible, setIsReportModalVisible] = useState(false);
    const [EstPayment, setEstPayment] = useState(null);
    const [isExpanded, setIsExpanded] = useState(false);
    const [displayedDescription, setDisplayedDescription] = useState("");

    const navigate = useNavigate();
    const modalContentRef = useRef(null);
    const detailRef = useRef(null);
    const modalRef = useRef(null);
    const shareModalRef = useRef(null);
    const owner_info = property?.owner_info;
    const images = property?.media ?? property?.images;
    const [selectedImage, setSelectedImage] = useState(images ? images[0] : "");
    const IMG_BASE_URL = config.get("API_URL");
    useEffect(() => {
        setDisplayedDescription(isExpanded ? property?.description : `${property?.description?.slice(0, 400)}...`);
    }, [isExpanded]);
    useEffect(() => {
        getEstimateInterestRate();
    }, []);
    const getEstimateInterestRate = async () => {
        const accessToken = localStorage.getItem("authUser");

        if (property.price && accessToken) {
            const token = accessToken.replace(/^"|"$/g, "");
            try {
                const response = await axios.post(
                    `${config.get("API_URL")}/property-services/calculate_mortgage`,
                    {
                        property_price: property.price,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setEstPayment(response);
            } catch (error) {
                console.log("Error::", error);
            }
        }
    };

    useEffect(() => {
        const accessToken = localStorage.getItem("authUser");
        if (accessToken) {
            const token = accessToken.replace(/^"|"$/g, "");
            const profileUrl = `${config.get("API_URL")}/user/profile`;
            fetch(profileUrl, {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    setProfileDetail({
                        firstName: data.first_name,
                        lastName: data.last_name,
                        email: data.email,
                        role: data.role,
                        userId: data.uuid,
                        phone: data.phone,
                        profile_pic: data.profile_pic,
                    });
                })
                .catch((error) => {
                    console.error("Error fetching profile:", error);
                });
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(favoriteProperties) && favoriteProperties.includes(property.ListingId)) {
            setIsFavorite(true);
        } else {
            setIsFavorite(false);
        }
    }, [favoriteProperties, property.ListingId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (shareModalRef.current && !shareModalRef.current.contains(event.target)) {
                setIsShareModal(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    if (!property) return <div className="tw-h-screen tw-flex tw-items-center tw-justify-center">No Property was found</div>;

    // Preview skeleton component
    const PreviewSkeleton = () => (
        <div className="tw-animate-pulse">
            {/* Header skeleton */}
            <div className="tw-w-full tw-h-16 tw-bg-gray-200 tw-mb-4"></div>

            {/* Buttons skeleton */}
            <div className="tw-w-full tw-flex tw-justify-center tw-mb-4">
                <div className="tw-max-w-6xl tw-w-full tw-px-5">
                    <div className="tw-flex tw-gap-2">
                        <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-20"></div>
                        <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-16"></div>
                    </div>
                </div>
            </div>

            {/* Image skeleton */}
            <div className="tw-w-full tw-flex tw-justify-center tw-mb-6">
                <div className="tw-max-w-6xl tw-w-full tw-px-5">
                    <div className="tw-w-full tw-h-96 tw-bg-gray-200 tw-rounded-lg"></div>
                </div>
            </div>

            {/* Content skeleton */}
            <div className="tw-min-h-screen tw-bg-white tw-p-6">
                <div className="tw-max-w-6xl tw-mx-auto tw-grid tw-grid-cols-1 lg:tw-grid-cols-[1fr_300px] tw-gap-6">
                    {/* Main content skeleton */}
                    <div>
                        {/* Title skeleton */}
                        <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-3/4 tw-mb-6"></div>

                        {/* Description skeleton */}
                        <div className="tw-space-y-2 tw-mb-6">
                            <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                            <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                            <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-2/3"></div>
                        </div>

                        {/* Facilities skeleton */}
                        <div className="tw-mb-8">
                            <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-w-24 tw-mb-4"></div>
                            <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4">
                                {[...Array(8)].map((_, i) => (
                                    <div key={i} className="tw-flex tw-items-center tw-gap-2">
                                        <div className="tw-h-6 tw-w-6 tw-bg-gray-200 tw-rounded"></div>
                                        <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-20"></div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Location skeleton */}
                        <div>
                            <div className="tw-h-6 tw-bg-gray-200 tw-rounded tw-w-20 tw-mb-4"></div>
                            <div className="tw-h-80 tw-bg-gray-200 tw-rounded-lg"></div>
                        </div>
                    </div>

                    {/* Sidebar skeleton */}
                    <div className="tw-hidden lg:tw-block">
                        <div className="tw-sticky tw-top-20 tw-bg-white tw-rounded-lg tw-border tw-p-6">
                            <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-12 tw-mb-2"></div>
                            <div className="tw-h-8 tw-bg-gray-200 tw-rounded tw-w-32 tw-mb-6"></div>
                            <div className="tw-h-10 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-4"></div>
                            <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-28 tw-mb-2"></div>
                            <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-1"></div>
                            <div className="tw-h-3 tw-bg-gray-200 tw-rounded tw-w-3/4 tw-mb-4"></div>
                            <div className="tw-h-10 tw-bg-gray-200 tw-rounded tw-w-full tw-mb-4"></div>
                            <div className="tw-h-10 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    // Show loading placeholder when property data is still loading
    if (!property?.ListingId && !property?.property_id) {
        return <PreviewSkeleton />;
    }

    const handleContactClick = async () => {
        const propertyAddressParts = [];

        if (property.StreetNumber) propertyAddressParts.push(property.StreetNumber);
        if (property.StreetName) propertyAddressParts.push(property.StreetName);
        if (property.StreetSuffix) propertyAddressParts.push(property.StreetSuffix);

        const propertyAddress = propertyAddressParts.join(" ");
        const initialMessage = `Hi ${profileData?.first_name}, how can we help you with ${propertyAddress}? Let me know what information I can get you!`;
        localStorage.setItem("initialMessage", initialMessage);
        localStorage.setItem("latestProperty", JSON.stringify(property));
        localStorage.setItem("propertyAddress", propertyAddress);
        if (owner_info && Object.keys(owner_info).length > 0) {
            navigate(`/chat?chat_id=${owner_info?.user_id}-${property.ListingId}&property_id=${property.ListingId}`, {
                state: {
                    seller_id: owner_info?.user_id,
                    name: property.name || "Unnamed item",
                    price: property.price,
                    property_id: property.property_id,
                    owner_email: owner_info?.email,
                    owner_name: owner_info?.name,
                    address: property.address,
                    owner_profile: owner_info?.profile,
                    user_id: owner_info?.user_id,
                    messageValue: initialMessage,
                },
            });
        } else {
            navigate(`/chat?chat_id=${property.ListingId}&property_id=${property.ListingId}`, {
                state: {
                    messageValue: initialMessage,
                    property_id: property.property_id,
                    name: property.name || "Unnamed item",
                    price: property.price,
                },
            });
        }
    };

    const handleGetQualifiedClick = () => {
        navigate("/services/financing");
    };

    // Open the tour request modal
    const handleRequestTourClick = () => {
        setShowTourModal(true);
    };

    // Close the tour request modal
    const handleCloseTourModal = () => {
        setShowTourModal(false);
        setSelectedDate(null);
    };

    const handleScheduleTour = () => {
        const accessToken = localStorage.getItem("authUser");
        if (!accessToken) {
            showErrorToast("You must be logged in to schedule a tour.");
            return;
        }

        if (!selectedDate) {
            showErrorToast("Please select a date for the tour.");
            return;
        }

        const token = accessToken.replace(/^"|"$/g, "");
        let tourRequestData = {
            request_tour: {
                requester_name: `${profileDetail.firstName} ${profileDetail.lastName}`,
                requester_id: profileDetail.userId,
                // Using moment.js to format the date
                requested_datetime: moment(selectedDate).format("YYYY-MM-DDTHH:mm:ss"),
            },
        };
        if (property?.property_id) {
            tourRequestData.property_id = property?.property_id;
        } else if (property?.ListingId) {
            tourRequestData.ListingId = property?.ListingId;
        }

        const tourUrl = `${config.get("API_URL")}/user/properties/add/property-tour`;

        fetch(tourUrl, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(tourRequestData),
        })
            .then((response) => {
                if (!response.ok) {
                    return response.json().then((errorData) => {
                        console.error("Error response data:", errorData); // Log error response
                        throw new Error(errorData.message || "Failed to schedule the tour.");
                    });
                }
                return response.json();
            })
            .then((data) => {
                showSuccessToast("Request Successfully Sent! Please check your email or app notifications for updates");
                handleCloseTourModal();
            })
            .catch((error) => {
                console.error("Error scheduling tour:", error);
                showErrorToast(error.message || "An error occurred. Please try again.");
            });
    };
    const onClickShare = () => {
        setIsShareModal(id.ListingId || id.property_id);
    };

    const returnImageUrl = (imageObj) => {
        // let imageUrl = imageObj?         .media_url ?? imageObj?.image_url;
        let imageUrl = imageObj?.image_url;
        if (imageUrl.includes("http")) {
            return imageUrl;
        } else {
            return IMG_BASE_URL + imageUrl;
        }
    };
    const formatPrice = (price) => {
        try {
            // Ensure the input is a valid number
            const numericPrice = typeof price === "number" ? price : parseFloat(price.toString().replace(/[^\d.-]/g, ""));

            // Return formatted price with commas, or fallback if invalid
            return numericPrice >= 0 ? numericPrice.toLocaleString("en-US") : "---";
        } catch (error) {
            console.error("Error formatting price:", error);
            return "---";
        }
    };

    const onPreQualified = () => {
        navigate("/services/financing");
    };

    return (
        <div className="">
            <div
                ref={modalContentRef}
                className="tw-bg-white tw-text-black  tw-overflow-y-auto tw-w-[100%] max-sm:tw-w-full max-sm:tw-h-[100dvh] tw-mx-auto  max-sm:tw-mt-0 "
            >
                {isShareModal && (
                    <ShareComponent
                        shareModalRef={shareModalRef}
                        selectedFile={{ url: `/public?propertyId=${isShareModal}` }}
                        onClose={() => setIsShareModal(false)}
                        property={property}
                    />
                )}
                {!isHeaderHide && (
                    <header className="tw-sticky tw-top-0 tw-z-[99] tw-bg-tertiary tw-w-full tw-shadow-md tw-shrink-0">
                        <div className="tw-w-full tw-max-w-none tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-py-3 tw-flex tw-items-center tw-justify-between tw-text-white tw-min-h-[60px] tw-gap-2 sm:tw-gap-4">
                            {/* Left Section - Back Button */}
                            <div className="tw-flex tw-items-center tw-shrink-0">
                                <button
                                    onClick={() => setPreviewModal(null)}
                                    className="tw-flex tw-items-center tw-gap-2 tw-px-3 lg:tw-px-4 tw-py-2 tw-bg-white tw-text-gray-800 tw-rounded-lg tw-border tw-hover:tw-bg-gray-50 tw-transition-colors tw-text-sm lg:tw-text-base"
                                >
                                    <span>Back</span>
                                </button>
                            </div>

                            {/* Center Section - Company Name */}
                            <div className="tw-flex-1 tw-flex tw-justify-center tw-min-w-0 tw-px-2">
                                <p className="tw-font-space-grotesk tw-font-semibold tw-text-[16px] sm:tw-text-[18px] tw-text-center tw-truncate">
                                    {config.get("COMPANY_NAME")}
                                </p>
                            </div>

                            {/* Right Section - Action Buttons */}
                            <nav className="tw-flex tw-items-center tw-gap-1 sm:tw-gap-2 tw-shrink-0">
                                {/* Favorite Button - Hidden on mobile */}
                                <button
                                    className="tw-hidden sm:tw-flex tw-items-center tw-gap-1 lg:tw-gap-2 tw-px-2 lg:tw-px-3 tw-py-2 tw-rounded-lg tw-transition-colors hover:tw-bg-white/10"
                                    onClick={() => handleFavorite(property)}
                                >
                                    {isFavorite ? (
                                        <>
                                            <FavoriteIcon style={{ color: "red" }} className="tw-w-4 lg:tw-w-5 tw-h-4 lg:tw-h-5" />
                                            <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden lg:tw-inline">Saved</span>
                                        </>
                                    ) : (
                                        <>
                                            <FavoriteBorderOutlinedIcon className="tw-w-4 lg:tw-w-5 tw-h-4 lg:tw-h-5 tw-text-white" />
                                            <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden lg:tw-inline">Save</span>
                                        </>
                                    )}
                                </button>

                                {/* Report Button */}
                                <button
                                    onClick={() => setIsReportModalVisible(true)}
                                    className="tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-2 tw-rounded-lg tw-transition-colors hover:tw-bg-white/10"
                                >
                                    <MdOutlineReportProblem className="tw-w-4 lg:tw-w-5 tw-h-4 lg:tw-h-5 tw-text-white" />
                                    <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden sm:tw-inline">Report</span>
                                </button>

                                {/* Share Button - Hidden on mobile */}
                                <button
                                    onClick={onClickShare}
                                    className="tw-hidden sm:tw-flex tw-items-center tw-gap-1 lg:tw-gap-2 tw-px-2 lg:tw-px-3 tw-py-2 tw-rounded-lg tw-transition-colors hover:tw-bg-white/10"
                                >
                                    <BsShare className="tw-w-4 lg:tw-w-5 tw-h-4 lg:tw-h-5 tw-text-white" />
                                    <span className="tw-text-xs lg:tw-text-sm tw-font-medium tw-hidden lg:tw-inline">Share</span>
                                </button>
                            </nav>
                        </div>
                    </header>
                )}

                {/* Buttons */}
                <div className="tw-w-full tw-flex tw-justify-center">
                    <div className="tw-p-5 lg:tw-px-0 tw-flex tw-gap-2 tw-w-full tw-max-w-6xl" ref={modalRef}>
                        <button className="tw-px-5 tw-py-1 tw-bg-[#EAEFF4]">Highlights</button>
                        <button
                            className="tw-px-5 tw-py-1"
                            onClick={() => {
                                if (detailRef.current) {
                                    detailRef.current.scrollIntoView({ behavior: "smooth" });
                                }
                            }}
                        >
                            Details
                        </button>
                    </div>
                </div>

                <div className="tw-flex tw-flex-col tw-items-center xl:tw-flex-col tw-w-full">
                    {/* SHOW IMAGES */}
                    <RenderImages
                        property={property}
                        images={images}
                        selectedImage={selectedImage}
                        setSelectedImage={setSelectedImage}
                        setSeeAllclicked={setSeeAllclicked}
                        returnImageUrl={returnImageUrl}
                    />
                </div>

                <div className="tw-min-h-screen  tw-bg-white tw-p-6">
                    <div className={`tw-container ${isChatScreen ? "" : "lg:tw-grid tw-grid-cols-[1fr_300px]"} tw-gap-6 tw-max-w-6xl tw-mx-auto`}>
                        {/* Main Content */}
                        <div>
                            {/* Header */}
                            <div className="tw-flex tw-justify-between tw-items-start tw-mb-6 tw-border-b tw-pb-4">
                                <h1 className="tw-text-[24px] tw-font-semibold">
                                    {property.StreetNumber} {property.StreetName} {property.StreetSuffix}
                                    {", "}
                                    {property.City}
                                    {", "}
                                    {property.StateOrProvince} {property.PostalCode}
                                </h1>
                                <div className={`tw-flex tw-gap-2 ${isChatScreen ? "tw-hidden" : ""}`}>
                                    {isFavorite ? (
                                        <button
                                            onClick={() => handleFavorite(property)}
                                            className="tw-flex tw-items-center tw-gap-1 tw-text-[#FF5757] tw-text-md"
                                        >
                                            <svg className="tw-h-[18px] tw-w-[18px]" fill="red" stroke="red" viewBox="0 0 24 24">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                                                />
                                            </svg>
                                            Save
                                        </button>
                                    ) : (
                                        <button
                                            onClick={() => handleFavorite(property)}
                                            className="tw-flex tw-items-center tw-gap-1 tw-text-[#FF5757] tw-text-md"
                                        >
                                            <svg className="tw-h-[18px] tw-w-[18px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                                                />
                                            </svg>
                                            Save
                                        </button>
                                    )}

                                    <button
                                        onClick={onClickShare}
                                        className={`tw-flex tw-items-center tw-gap-1 tw-text-gray-600 tw-text-md ${isChatScreen ? "tw-hidden" : ""}`}
                                    >
                                        <svg className="tw-h-[16px] tw-w-[16px]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth="2"
                                                d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                                            />
                                        </svg>
                                        Share
                                    </button>
                                </div>
                            </div>
                            <div className={`${isChatScreen ? "tw-block" : "tw-block lg:tw-hidden"}`}>
                                <PriceAndContactCard
                                    handleContactClick={handleContactClick}
                                    handleRequestTourClick={handleRequestTourClick}
                                    onPreQualified={onPreQualified}
                                    property={property}
                                />
                            </div>
                            {/* Description */}
                            <div className="tw-mb-6">
                                <p className="tw-text-black tw-text-[16px] tw-leading-relaxed">
                                    {displayedDescription}
                                    {property?.description && property.description?.length > 400 && (
                                        <>
                                            {isExpanded ? (
                                                <button
                                                    onClick={() => setIsExpanded((pre) => !pre)}
                                                    className="tw-text-black tw-font-semibold tw-ml-1"
                                                >
                                                    Read Less
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => setIsExpanded((pre) => !pre)}
                                                    className="tw-text-black tw-font-semibold tw-ml-1"
                                                >
                                                    Read full description
                                                </button>
                                            )}
                                        </>
                                    )}
                                </p>
                            </div>

                            {/* Facilities */}
                            <div className="tw-mb-8">
                                <h2 className="tw-text-[20px] tw-font-semibold tw-mb-4">Facilities</h2>
                                <div className={`tw-grid ${isChatScreen ? "tw-grid-cols-2" : "tw-grid-cols-4"} tw-gap-4`}>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <IoBedOutline className="tw-text-[22px]" />

                                        <span className="tw-text-[16px]">{property.beds || "---"} Bedrooms</span>
                                    </div>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <TbBath className="tw-text-[22px]" />
                                        <span className="tw-text-[16px]">{property.baths || "---"} Bathrooms</span>
                                    </div>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <RxDimensions className="tw-text-[22px]" />
                                        <span className="tw-text-[16px]">{property.LivingArea || "--- "} sqft</span>
                                    </div>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <PiBarbell className="tw-text-[22px]" />
                                        <span className="tw-text-[16px]">No Gym</span>
                                    </div>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <FaSunPlantWilt className="tw-text-[22px]" />

                                        <span className="tw-text-[16px]">Garden View</span>
                                    </div>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        <FaSwimmingPool className="tw-text-[22px]" />

                                        <span className="tw-text-[16px]">Pool</span>
                                    </div>
                                    <div className="tw-flex tw-items-center tw-gap-2">
                                        {/* <BiSolidCarGarage className="tw-text-[24px]" /> */}
                                        <PiGarage className="tw-text-[22px]" />
                                        <span className="tw-text-[16px]">Garage</span>
                                    </div>
                                </div>
                            </div>

                            {/* Location */}
                            <div>
                                <h2 className="tw-text-[20px] tw-font-semibold tw-mb-4">Location</h2>
                                <div className="tw-h-[300px] tw-bg-background_color tw-rounded-lg tw-overflow-hidden">
                                    {" "}
                                    <LeafletLocateMapLocation
                                        monthlyPayment={EstPayment?.monthly_payment || "0"}
                                        agentName={owner_info?.name || "CS"}
                                        currentValue={formatPrice(property.price || 0)}
                                        percentageChange={property.percentage_change || "0"}
                                        yearsSpan={property.years_span || "0"}
                                        property={property}
                                        onContactClick={handleContactClick}
                                        onQualifyClick={handleGetQualifiedClick}
                                    />
                                </div>
                            </div>

                            {/* More Details Section */}
                            <div className="tw-mt-8">
                                <h2 ref={detailRef} className="tw-text-[20px] tw-font-semibold tw-mb-4">
                                    More Details And Facts
                                </h2>
                                <div className="">
                                    <h3 className="tw-font-medium tw-mb-2 tw-text-[18px] tw-bg-background_color tw-p-4 tw-rounded">Interior</h3>
                                    <div>
                                        <DetailsAndFacts info={property} />
                                    </div>
                                </div>
                                {property?.appliances && property?.appliances.length > 0 && (
                                    <div className="">
                                        <h3 className="tw-text-[20px] *:tw-font-medium tw-mb-2 tw-bg-background_color tw-p-4 tw-rounded">
                                            Appliances
                                        </h3>
                                        <div>
                                            <FeatureChipsContainer showOnly={true} array={property?.appliances} isDisable heading="Appliances" />
                                        </div>
                                    </div>
                                )}{" "}
                                {property?.kitchen_features && property?.kitchen_features > 0 && (
                                    <div className="">
                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Kitchen </h3>
                                        <div>
                                            <FeatureChipsContainer showOnly={true} array={property?.kitchen_features} isDisable />
                                        </div>
                                    </div>
                                )}{" "}
                                {property?.parking && property?.parking > 0 && (
                                    <div className="">
                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Parking </h3>
                                        <div>
                                            <FeatureChipsContainer showOnly={true} array={property?.parking} isDisable />
                                        </div>
                                    </div>
                                )}
                                {property?.construction && property?.construction > 0 && (
                                    <div className="">
                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Construction </h3>
                                        <div>
                                            <FeatureChipsContainer showOnly={true} array={property?.construction} isDisable />
                                        </div>
                                    </div>
                                )}{" "}
                                {property?.PoolFeatures && property?.PoolFeatures > 0 && (
                                    <div className="">
                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Pool Featurres </h3>
                                        <div>
                                            <FeatureChipsContainer showOnly={true} array={property?.PoolFeatures} isDisable />
                                        </div>
                                    </div>
                                )}{" "}
                                {property?.Sewer && property?.PoolFeatures > 0 && (
                                    <div className="">
                                        <h3 className="tw-font-medium tw-mb-2 tw-bg-gray-100 tw-p-4 tw-rounded">Sewer </h3>
                                        <div>
                                            <FeatureChipsContainer showOnly={true} array={property?.Sewer} isDisable />
                                        </div>
                                    </div>
                                )}{" "}
                            </div>
                        </div>

                        {/* Price Card - Now in grid layout */}
                        <div className={`${isChatScreen ? "tw-hidden" : "tw-hidden lg:tw-block"}`}>
                            <PriceAndContactCard
                                handleContactClick={handleContactClick}
                                handleRequestTourClick={handleRequestTourClick}
                                onPreQualified={onPreQualified}
                                property={property}
                            />
                        </div>
                    </div>
                </div>

                {propertiesArray && propertiesArray.length > 0 && (
                    <div className=" tw-w-full  tw-flex tw-justify-center">
                        <div className="tw-p-10 tw-max-w-6xl tw-w-full lg:tw-px-0">
                            <p className="tw-text-tertiary tw-text-[24px] tw-font-[700]">Similar Homes</p>
                            <div className="tw-flex tw-gap-5 tw-overflow-x-scroll tw-mt-5 tw-w-full">
                                {propertiesArray?.map((itm, index) => (
                                    <div
                                        key={index}
                                        className="tw-min-w-[300px]"
                                        onClick={() => {
                                            setProperty(itm);
                                            setSelectedImage(itm.images[0]);
                                            if (modalRef.current) {
                                                modalRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
                                            }
                                        }}
                                    >
                                        <PropertyComponent showWidth={true} item={itm} width={300} setPreviewModal={() => setProperty(itm)} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}
                <div className=" tw-w-full  tw-flex tw-justify-center">
                    <div className="tw-p-10 tw-max-w-6xl lg:tw-px-0 tw-w-full max-sm:tw-p-5">
                        <MLSDisclaimer />
                    </div>
                </div>
                {seeAllclicked && <SeeAllImages images={images} setSeeAllclicked={setSeeAllclicked} />}
                {showTourModal && (
                    <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50 tw-flex tw-items-center tw-justify-center tw-z-50">
                        <div className="tw-bg-white tw-p-4 md:tw-p-8 tw-rounded-lg tw-shadow-lg tw-z-50">
                            <h3 className="tw-text-xl tw-font-bold tw-mb-4">Request a Tour</h3>
                            <div className="tw-flex tw-gap-4">
                                <CustomDatePickerComponent selectedDate={selectedDate} setSelectedDate={setSelectedDate} />
                            </div>
                            <div className="tw-flex tw-justify-between tw-mt-4">
                                <button className="tw-bg-orange-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md" onClick={handleCloseTourModal}>
                                    Cancel
                                </button>
                                <button className="tw-bg-green-500 tw-text-white tw-px-4 tw-py-2 tw-rounded-md" onClick={handleScheduleTour}>
                                    Schedule
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {isReportModalVisible && <ReportProperty property={property} onClose={() => setIsReportModalVisible(false)} />}
            </div>
        </div>
    );
};

export default PropertyDetailPage;
